import { fqdnRegex } from "constants/regexp";

export const isValidFqdn = (fqdn: string): boolean => fqdnRegex.test(fqdn);
